import React, { useEffect, useState } from 'react'
import { CgPushUp } from 'react-icons/cg'

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false)

  // 判断是否需要显示按钮
  const checkScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop
    const hasScroll = document.documentElement.scrollHeight > window.innerHeight
    setVisible(hasScroll && scrollY > 100)
  }

  useEffect(() => {
    checkScroll() // 初始化判断一次
    window.addEventListener('scroll', checkScroll)
    window.addEventListener('resize', checkScroll)
    return () => {
      window.removeEventListener('scroll', checkScroll)
      window.removeEventListener('resize', checkScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!visible) return null

  return (
    <button
      onClick={scrollToTop}
      className="fixed w-12 h-12 z-[40] bg-white hover:bg-gray-50 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center rounded-full cursor-pointer border border-gray-200 text-gray-700 hover:text-blue-600"
      style={{
        bottom: '2rem', // 32px - 在 Crisp 按钮（88px）下方
        right: '2rem', // 32px - 与 Crisp 按钮对齐
      }}
      title="回到顶部"
      aria-label="回到顶部"
    >
      <CgPushUp className="text-xl" />
    </button>
  )
}

export default BackToTopButton
